import Pricing from '~/components/Pricing';
import pricingStyles from '~/components/Pricing.module.css';
import type { LinksFunction, V2_MetaFunction } from '~/remix';

export let meta: V2_MetaFunction = () => [
  { title: 'Sunset Messages - Pricing' },
];

export let links: LinksFunction = () => [
  { rel: 'stylesheet', href: pricingStyles },
];

export default function () {
  return (
    <div className="bg-background-dark">
      <div className="sticky top-0 z-20 w-full bg-accent-dark/70 py-2 text-white">
        <h1 className="text-center text-2xl font-bold">Pricing</h1>
      </div>

      <div className="mt-8">
        <div className="mx-auto bg-white px-4 pt-0 pb-4 sm:px-8 sm:pb-8 sm:pt-4">
          <Pricing hideHeader />
        </div>
      </div>
    </div>
  );
}
